import React, { useContext, useEffect, useState } from 'react';
import gql from 'graphql-tag';
import * as qs from 'query-string';
import { useQuery } from '@apollo/react-hooks';
import { useParams, useLocation } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { growlErrors } from '../../utils/NotificationUtil';
import { NotificationContext } from '../../components/GrowlNotifications';
import StopSubscription from './StopSubscription';

const MANAGE_ACCOUNTS_CONFIG_QUERY = gql`
  query manageAccountsConfigQuery($accountId: ID!) {
    account(id: $accountId) {
      managedAccounts {
        id
        subscriptionInformation {
          currentSubscription {
            endsOn
          }
        }
      }
    }
  }
`;

const DEFAULT_ACCOUNT_STATE = {
  id: null,
  displayName: null,
  subscriptionInformation: {
    currentSubscription: {
      endsOn: null,
    },
  },
};

const StopSubscriptionForClient = () => {
  const growl = useContext(NotificationContext);
  const { aid: managingAccountId } = useParams();
  const { search } = useLocation();
  const { clientId } = qs.parse(search);

  const [clientAccount, setClientAccount] = useState(DEFAULT_ACCOUNT_STATE);

  const { loading, error, data } = useQuery(MANAGE_ACCOUNTS_CONFIG_QUERY, {
    variables: {
      accountId: managingAccountId,
    },
    fetchPolicy: 'no-cache',
  });

  const { account: accountFromQuery } = data;

  useEffect(() => {
    if (accountFromQuery) {
      setClientAccount(accountFromQuery.managedAccounts.filter(a => a.id === clientId)[0]);
    }
    // eslint-disable-next-line
  }, [accountFromQuery]);

  if (loading || clientAccount === DEFAULT_ACCOUNT_STATE) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  return <StopSubscription managingAccountId={managingAccountId} clientAccount={clientAccount} />;
};

export default StopSubscriptionForClient;
